

/**
 * Takes a URLSearchParams object and returns a string that represents the search query portion of a URL with any encoded commas replaced with commas. 
 * This is necessary because URLSearchParams.toString() encodes commas as %2C, but the search API expects commas to separate multiple values.
 * @param searchParams 
 * @returns 
 */
export function queryToSearch(searchParams: URLSearchParams): string {
  return searchParams.toString()
    .replace(/%2C/g, ',')
}